/**
 * --------------------------------------------------------------------------------------------
 * A simple typecheker
 *
 * USAGE:
 *   let x = 9;
 *   let y = { name : 'Test' };
 *   let fn = function(){};
 *   let obj = new Error();
 *   typeof(x).is(Number) // true
 *   typeof(y).is(Object) // true
 *   typeof(fn).is(Function) // true
 *   typeof(obj).is(Error) // true
 * --------------------------------------------------------------------------------------------
 */

export default function ( data ) {
  return {
    data : data,
    is : function (type) {
      return ( this.data instanceof type )
    },
    isNot : function (type) {
      return !(this.data instanceof type)
    }
  }
}
